import styled from 'styled-components'

interface selectProps {
  name: string
  className: string
  label?: string
  placeholder?: string
  children?: string
}

const SelectContainer = styled.div`
  width: 350px;
`

const SelectWrapper = styled.select`
  width: 100%;
  border-radius: 9px;
  padding: 10px 22px;
  outline: none;
  height: 60px;
  margin-bottom: 20px;
  padding-right: 10px;
  font-family: ${({ theme }) => theme.fontFamily.interSemiBold};

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 295px;
    margin: 0 0 30px 0px;
  }
`

const BankSettingsSelectInput = styled(SelectWrapper)`
  margin: 0;
  height: 50px;
  margin-bottom: 30px;
  width: -webkit-fill-available;
  border: 1px solid #858c94;
  font-family: ${({ theme }) => theme.colors.gray};
  font-style: normal;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSize.x5};
  color: ${({ theme }) => theme.colors.gray};
  opacity: 0.8;
  background: transparent;
  /* padding-left: 16px; */
  /* padding: 10px 22px; */
  padding: 0 16px;

  &:focus {
    border: 1px solid blue;
  }
`

const SavingsSelectInput = styled(SelectWrapper)`
  height: 45px;
  width: -webkit-fill-available;
  border: 1px solid #858c94;
  font-family: ${({ theme }) => theme.colors.gray};
  font-style: normal;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSize.x5};
  color: ${({ theme }) => theme.colors.gray};
  opacity: 0.8;
  padding-left: 16px;
  margin-bottom: 0px;
`

const RegisterSelectInput = styled(SelectWrapper)`
  /*    
   width:320px;
   height:50px; */
`

const SelectInput = ({
  name,
  className,
  placeholder,
  children,
}: selectProps) => {
  return (
    <SelectContainer>
      <SelectWrapper name={name} className={className}>
        <option value="">{placeholder}</option>
        {children}
      </SelectWrapper>
    </SelectContainer>
  )
}

export {
  SelectInput,
  RegisterSelectInput,
  SelectWrapper,
  BankSettingsSelectInput,
  SavingsSelectInput,
}
